import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './AddProperty.module.scss';
import {Container, Row, Col, ProgressBar} from "react-bootstrap";
import * as Components from './components/index';
import * as propertyActions from '../../redux/action/property.action';
import propertyTypeOptions from "../../asset/data/propertyTypes";
import transactionTypeOptions from "../../asset/data/transactionTypes";

class AddProperty extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      firstStep: {},
      secondStep: {},
      isLoading: false
    }
  }

  async gotoNextForm(index, data) {
    if (index === 1) {
      this.setState({step: 2, firstStep: data});
    } else if (index === 2) {
      await this.setState({isLoading: true, secondStep: data});
      this.saveProperty();
    }
  }

  gotoPreviousForm(data) {
    this.setState({step: 1, secondStep: data});
  }

  async saveProperty() {
    const { firstStep, secondStep } = this.state;
    try {
      await this.props.addProperty({...firstStep, ...secondStep, propertyName: this.getPropertyName()});
      this.setState({step: 3, isLoading: false});
    } catch (e) {
      this.setState({isLoading: false});
    }
  }

  getPropertyName() {
    const { transactionType, propertyType } = this.state.firstStep;
    const { foundation } = this.state.secondStep;

    let propertyTypeLabel = '';
    let transactionTypeLabel = '';
    if (propertyType) {
      propertyTypeLabel = propertyTypeOptions.find((item) => item.value === propertyType).label;
    }
    if (transactionType) {
      transactionTypeLabel = transactionTypeOptions.find((item) => item.value === transactionType).label;
    }

    return `${propertyTypeLabel} ${foundation ? `${foundation} متری`: ''} ${transactionTypeLabel ? `برای ${transactionTypeLabel}` : ''}`;

  }

  render() {
    const { step, firstStep, secondStep } = this.state;

    return (
        <React.Fragment>
          <Container fluid className={`p-0`}>
            <div className={style.background}>
              <Row className={style.content}>
                <Col md={2} />
                <Col md={8} className={'pt-4 px-5'}>
                  <div className={`${style.property_info}`}>
                    {
                      step === 1 && <Components.FirstStep data={firstStep} onNext={(data) => this.gotoNextForm(1, data)} />
                    }
                    {
                      step === 2 &&
                      <Components.SecondStep
                          data={secondStep}
                          onNext={(data) => this.gotoNextForm(2, data)}
                          onBack={(data) => this.gotoPreviousForm(data)}
                          propertyType={firstStep ? firstStep.propertyType : 'APARTMENT'}
                          transactionType={firstStep ? firstStep.transactionType : 'SELL'}
                      />
                    }
                    {
                      step === 3 ? (
                        <Components.ThirdStep />
                      ) : (
                          <Container className={'mt-3'}>
                            <Row>
                              <Col className={'text-center'}>
                                <span className={style.level}>مرحله {step} از ۲</span>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <ProgressBar now={(100 / 2) * step} />
                              </Col>
                            </Row>
                          </Container>
                      )
                    }
                  </div>
                </Col>
                <Col md={2} />
              </Row>
            </div>
          </Container>
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  addProperty: (data) => dispatch(propertyActions.addProperty(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddProperty));
